import { useState, useEffect } from 'react';

/**
 * Custom hook for managing citation display preferences
 * Citations are OFF by default and preference is persisted in localStorage
 */
export const useCitationToggle = () => {
  // Default to false (citations hidden) as requested
  const [showCitations, setShowCitations] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem('showCitations');
      // Default to false if no preference stored
      return stored === 'true';
    } catch (error) {
      console.warn('Failed to read citation preference from localStorage:', error);
      return false; // Default to hidden
    }
  });

  // Persist preference changes to localStorage
  useEffect(() => {
    try {
      localStorage.setItem('showCitations', showCitations.toString());
    } catch (error) {
      console.warn('Failed to save citation preference to localStorage:', error);
    }
  }, [showCitations]);

  const toggleCitations = () => {
    setShowCitations(prev => !prev);
  };

  const setCitationsVisible = (visible: boolean) => {
    setShowCitations(visible);
  };

  // Provide both the boolean and its inverse for convenience
  return {
    showCitations,
    hideCitations: !showCitations, // For existing hideCitations prop pattern
    toggleCitations,
    setCitationsVisible
  };
};

export default useCitationToggle;